import { useState } from 'react';
import { Icon } from '@/components/Icon';
import { haptic, openExternalLink } from '@/lib/telegram';
import { ImportantNote, Italic, SetupSheet, StepHead, StepHero } from './parts';

interface SetupAppProps {
  onNext: () => void;
}

const HAPP_IOS_URL = 'https://apps.apple.com/app/happ-proxy-utility/id6504287215';
const HAPP_FALLBACK_URL = 'https://www.happ.su/main';

export function SetupApp({ onNext }: SetupAppProps) {
  const [showSheet, setShowSheet] = useState(false);

  const openSheet = () => {
    haptic('medium');
    setShowSheet(true);
  };
  const closeSheet = () => setShowSheet(false);

  return (
    <div
      style={{
        padding: '12px 18px 130px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <StepHead
        n={1}
        eyebrow="приложение"
        title={
          <>
            скачай <Italic>happ.</Italic>
          </>
        }
        sub="happ — клиент vpn для ios. бесплатно, из app store. вернись сюда после установки"
      />

      <StepHero glyph="i" label="приложение happ" />

      <ImportantNote icon="info">
        <span style={{ color: 'var(--ink)' }}>обязательно вернись на этот экран</span> после
        установки — без шага 2 vpn не подключится. ничего сложного, просто не закрывай
        мини-приложение
      </ImportantNote>

      <div style={{ flex: 1 }} />

      <button
        onClick={openSheet}
        className="btn btn-moss"
        style={{ width: '100%', height: 54, fontSize: 14.5, marginBottom: 10 }}
      >
        <Icon name="install" size={15} stroke="#fff" sw={2} />
        установить happ
      </button>
      <button
        onClick={() => {
          haptic('light');
          onNext();
        }}
        className="btn btn-paper"
        style={{ width: '100%', height: 50, fontSize: 13.5 }}
      >
        уже установлено — следующий шаг
        <Icon name="arrow" size={13} stroke="var(--ink)" sw={2} />
      </button>

      {showSheet && (
        <SetupSheet
          title="важная информация"
          onClose={closeSheet}
          primary={{
            label: 'хорошо, перейти к установке',
            onClick: () => {
              closeSheet();
              openExternalLink(HAPP_IOS_URL);
            },
          }}
          secondary={{
            label: 'версия для зарубежного app store',
            onClick: () => {
              closeSheet();
              openExternalLink(HAPP_FALLBACK_URL);
            },
          }}
        >
          после установки <span style={{ color: 'var(--ink)' }}>обязательно вернись сюда</span> и
          нажми «следующий шаг», чтобы добавить конфигурацию в happ. без этого vpn не заработает
        </SetupSheet>
      )}
    </div>
  );
}
